module.exports = __webpack_public_path__ + "static/media/charpente.5f389e57.png";